// ─── Workshop Truck Availability Tracker ───
// Layout – Application shell wrapper
// IASL Technical Academy / Lafarge Driving Institute, Nigeria

import { Outlet } from 'react-router-dom'
import NavBar from './NavBar'

interface LayoutProps {
  lastSynced: string | null
  isLoading: boolean
  onRefresh: () => void
}

export default function Layout({ lastSynced, isLoading, onRefresh }: LayoutProps) {
  return (
    <div className="min-h-screen bg-[#F3F4F6]">
      <NavBar
        lastSynced={lastSynced}
        isLoading={isLoading}
        onRefresh={onRefresh}
      />

      {/* Main content – offset for fixed navbar (64px) + tabs (~48px) = 112px */}
      <main className="pt-[112px] px-6 py-6 max-w-[1400px] mx-auto">
        <Outlet />
      </main>
    </div>
  )
}
